const state = {
  categories: [{ name: 'Wedding Rings' }, { name: 'Engagement Rings' }, { name: 'Pendants, Earrings, and Other Accessories' }],
  paginationcount: [{ name: '5' }, { name: '10' }, { name: '25' }, { name: '50' }]
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchCategories({ commit }, payload) {},
    fetchPaginationCount({ commit }, payload) {}
  }
};
